import { useState } from 'react';

import { copyToClipboard, navigationProvider } from '@40seas/payments-shared';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, Typography } from '@mui/material';
import { Button } from 'react-admin';

export const WrongToken: React.FC<{ email?: string }> = ({ email }: { email?: string }) => {
    const [linkCopied, setLinkCopied] = useState(false);

    return (
        <>
            <h2>
                This link cannot be accessed
                <br />
                through your account
                <br />
                {email}
            </h2>
            <Typography mb={3} maxWidth={'400px'}>
                This link is for your buyer. Please copy and share it with your buyer so they can access it through their account.
            </Typography>
            <Button
                style={{ padding: '10px' }}
                variant="outlined"
                label="Copy link"
                startIcon={<ContentCopyIcon />}
                onClick={async () => {
                    await copyToClipboard(Promise.resolve(window.location.href));
                    setLinkCopied(true);
                }}
            />

            {linkCopied && <div style={{ color: 'green', paddingTop: 5 }}>Link copied</div>}
            <Box mt={3}>
                For any questions please contact <br />
                <a href="mailto:support@40seas.com" target="_blank" rel="noopener noreferrer">
                    support@40seas.com
                </a>{' '}
            </Box>
            <br />
            <Button variant="contained" label="Go to dashboard" onClick={() => navigationProvider.navigationToDashboard()} />
        </>
    );
};
